import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/normal_comment_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  content_cont: {
    model_name: 'NormalComment',
    column_type: 'string',
    column_name: 'content',
  },
  deleted_at_not_null: {
    column_type: 'boolean',
    model_name: 'NormalComment',
    column_name: 'deletedAt',
  },
  position_not_null: {
    column_type: 'boolean',
    model_name: 'NormalComment',
    column_name: 'position',
  },
  parent_id_null: {
    column_type: 'boolean',
    model_name: 'NormalComment',
    column_name: 'parentId',
  },
  commentable_of_any_type_type_eq: {
    column_type: 'type',
    extra: {
      options: [],
    },
    model_name: 'Post',
    column_name: 'type',
  },
  commentable_id_eq: {
    model_name: 'NormalComment',
    column_type: 'string',
    column_name: 'commentableId',
  },
  parent_id_eq: {
    column_type: 'belongs_to',
    column_name: 'parent',
    extra: {
      model_name: 'Comment',
    },
    model_name: 'NormalComment',
  },
  parent: {
    column_type: 'belongs_to',
    column_name: 'parent',
    extra: {
      model_name: 'Comment',
    },
    model_name: 'NormalComment',
  },
  root_id_eq: {
    column_type: 'belongs_to',
    column_name: 'root',
    extra: {
      model_name: 'Comment',
    },
    model_name: 'NormalComment',
  },
  root: {
    column_type: 'belongs_to',
    column_name: 'root',
    extra: {
      model_name: 'Comment',
    },
    model_name: 'NormalComment',
  },
  admin_read_eq: {
    column_type: 'boolean',
    model_name: 'NormalComment',
    column_name: 'adminRead',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return entityColumnsExtend(shareColumnsExtend('NormalComment', columns), { filterColumnsExtend })
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('NormalComment', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
